import { useMessageComposer } from './useMessageComposer';
import { useStateStore } from '../../../store';
const stateSelector = (state) => ({
    attachments: state.attachments,
});
export const useAttachmentManagerState = () => {
    const { attachmentManager } = useMessageComposer();
    const { attachments } = useStateStore(attachmentManager.state, stateSelector);
    return {
        attachments,
        availableUploadSlots: attachmentManager.availableUploadSlots,
        blockedUploadsCount: attachmentManager.blockedUploadsCount,
        failedUploadsCount: attachmentManager.failedUploadsCount,
        isUploadEnabled: attachmentManager.isUploadEnabled,
        pendingUploadsCount: attachmentManager.pendingUploadsCount,
        successfulUploadsCount: attachmentManager.successfulUploadsCount,
        uploadsInProgressCount: attachmentManager.uploadsInProgressCount,
    };
};
